import React from "react";
import { WCUComponent } from "./wcu.commponent";

interface IWhyChooseUsContainerComponentProps { }

export const WhyChooseUsContainerComponent: React.FC<
    IWhyChooseUsContainerComponentProps
> = (props: IWhyChooseUsContainerComponentProps) => {
    const section = {
        title: "Why Choose Us?",
        subTitle:
            "Your all-in-one outsourcing partner for streamlined operations and expert support.",
        wcu: [
            {
                title: "Experience & Expertise",
                subTitle:
                    "Access a team of seasoned payroll professionals who bring in-depth knowledge and a proven track record to ensure accuracy and compliance for your payroll processes.",
                icon: "archive",
                delay: "200",
            },
            {
                title: "Employee Self Service",
                subTitle:
                    "Empower your employees with a user-friendly platform to access their pay stubs, tax documents, and other important payroll information, reducing administrative burden.",
                icon: "person",
                delay: "300",
            },
            {
                title: "Employee Help Desk",
                subTitle:
                    "Provide your employees with dedicated support for their payroll-related queries, ensuring prompt and accurate assistance to enhance satisfaction and resolve issues efficiently.",
                icon: "telephone",
                delay: "400",
            },
        ],
    };

    return (
        <section id="stats" className="stats section dark-background">
            <img loading="lazy" src="/assets/img/stats-bg.jpg" alt="stats-bg-image" data-aos="fade-in" />

            <div
                className="container position-relative"
                data-aos="fade-up"
                data-aos-delay="100"
            >
                <div className="subheading">
                    <h1 className="fs-2 fw-bold">{section.title}</h1>
                    <p>{section.subTitle}</p>
                </div>

                <div className="row gy-4">
                    {section.wcu?.map((wcu: any) => {
                        return <WCUComponent key={wcu.title} {...wcu} />;
                    })}
                </div>
            </div>
        </section>
    );
};
